export default "__VITE_ASSET__CHWc5g1q__"